module.exports = __webpack_public_path__ + "img/furniture-es.4a7fc28.webp";